// import { SchemeTypes } from '../../../../config';
import { LanguagesEnum } from '../../../../config/languages';

const CONFIGURATION = {};

export const Translations = {
  form_error_required: {
    [LanguagesEnum.English]: 'This is required',
    [LanguagesEnum.Greek]: 'Υποχρεωτικό πεδίο',
  },
  identification_details_header: {
    [LanguagesEnum.English]: 'Identification Details',
    [LanguagesEnum.Greek]: 'Identification Details',
  },
  vat_number_control: {
    [LanguagesEnum.English]: 'VAT Number',
    [LanguagesEnum.Greek]: 'VAT Number',
  },
  company_name_control: {
    [LanguagesEnum.English]: 'Company Name',
    [LanguagesEnum.Greek]: 'Company Name',
  },
  vat_return_id: {
    [LanguagesEnum.English]: 'VAT Return ID',
    [LanguagesEnum.Greek]: 'VAT Return ID',
  },
  vat_return_version_id: {
    [LanguagesEnum.English]: 'VAT Return Version ID',
    [LanguagesEnum.Greek]: 'VAT Return Version ID',
  },
  vat_return_reference: {
    [LanguagesEnum.English]: 'VAT Return Reference',
    [LanguagesEnum.Greek]: 'VAT Return Reference',
  },
};

export default CONFIGURATION;
